var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.customernumber},[_c('IconSelect',{class:_vm.$style.icon,attrs:{"icon":"user","height":"20","width":"20","icon-props":{ 'stroke-width': 2 }}}),_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.username))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }